import React from "react";
import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router-dom";
import "./index.css";

type NestButtonProps = {
  isNest?: boolean;
};

export default function NestButton({ isNest }: NestButtonProps) {
  const { t } = useTranslation();
  const location = useLocation();

  return (
    <Link
      to={{
        pathname: isNest ? "/inbound-central" : "/inbound-central/nest",
        search: location.search,
      }}
      className="nest-button-link-wrapper"
    >
      <div
        className={`nest-button ${isNest ? "nest-button--nest" : "nest-button--default"}`}
      >
        {t("nest_go", { isNest })}
      </div>
    </Link>
  );
}
